import { markRaw } from 'vue';
import { RouterLink, type RouteLocationRaw } from 'vue-router';

// Get the component to use based on the `to` prop
export const getComponentType = (to?: RouteLocationRaw) => {
  if (typeof to === 'object' && to !== null) {
    return markRaw(RouterLink);
  }
  if (typeof to === 'string' && to.startsWith('/')) {
    return markRaw(RouterLink);
  }
  if (to) {
    return 'a';
  }
  return 'div';
};

// Get the props related to hyperlinks
export const getLinkProps = (to?: RouteLocationRaw) => {
  if (typeof to === 'object' && to !== null) {
    return to;
  }
  if (typeof to === 'string' && to.startsWith('/')) {
    return { to };
  }
  if (to) {
    return { href: to, target: '_blank', rel: 'noopener noreferrer' };
  }
  return {};
};
